import React, { useState } from 'react'
import { AppProps } from 'next/app'
import { store } from '@/app/store'
import { Provider as ReduxProvider } from 'react-redux'
import { QueryClient, QueryClientProvider } from 'react-query'
import 'tailwindcss/tailwind.css'
import '@/styles/globals.scss'
import '@/styles/Common.scss'
import '@/styles/component/Dialog.scss'
import '@/styles/component/Thumbnail.scss'
import '@/styles/component/Form.scss'
import '@/styles/component/Tag.scss'
import '@/styles/component/Detail.scss'
import '@/styles/component/SwiperMap.scss'
import PageView from '@/lib/usePageHooks'
// import { usePageViewAnalytics, GoogleAnalytics } from '@/lib/gtag'

function MyApp({ Component, pageProps }: AppProps) {
  // react-queryのクライアント定義
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            retry: false,
          },
        },
      })
  )

  return (
    <>
      <QueryClientProvider client={queryClient}>
        <ReduxProvider store={store}>
          <PageView />
          <Component {...pageProps} />
        </ReduxProvider>
      </QueryClientProvider>
    </>
  )
}

export default MyApp
